module.exports = __webpack_public_path__ + "static/media/gradienta-ix_kUDzCczo-unsplash.2a88c54a.jpg";